const middlewareUrl = 'https://dban.apps.di.givaudan.com/api';

export const environment = {
  production: true,
  hasBasicAuth: false,
  localSSR: false,
  middlewareUrl,
  domain: 'https://dban.apps.di.givaudan.com',
  allowedUrls: [middlewareUrl],
  cognito: { domain: 'https://givaudantestpublic.auth.eu-central-1.amazoncognito.com', },
  auth: {
    issuer: 'https://cognito-idp.eu-central-1.amazonaws.com/eu-central-1_lZwmEbz6d',
    clientId: 'e2lnckarsb2fsmqf4bc2g6tfc',
    responseType: 'code',
    scope: 'openid profile',
    showDebugInformation: true,
    checkOrigin: true,
    redirectUri: '/login/callback',
    postLogoutRedirectUri: 'https://dban.apps.di.givaudan.com/logout',
    strictDiscoveryDocumentValidation: false,
  },
  recaptcha: {
    siteKey: '6LegMG4rAAAAAJaw1a3Y5GQpSM-9OPTU1_N4-ZUH',
  },
  whatsappGivaudan: 'https://api.whatsapp.com/send/?phone=6281119911360&text&type=phone_number&app_absent=0',
  builderIoApiKey: '24b4c97ac8924bdd89c7ccc886140f5b',
  googleTagManagerId: 'GTM-KGGFGS3B',
  gtmAuth: 'CzJ-yoVCkFsiOme47yfXMA',
  gtmPreview: 'env-16',
  env: 'dev',
  locale: 'id'
};
